export const decodeJwtToken = (BearerToken) => {
  let token = BearerToken ? BearerToken : sessionStorage.getItem('token');
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};
